/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Choose_Audio_Track_Aria_LabelInputs */

const en_player_choose_audio_track_aria_label = /** @type {(inputs: Player_Choose_Audio_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose audio track`)
};

const fr_player_choose_audio_track_aria_label = /** @type {(inputs: Player_Choose_Audio_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir la piste audio`)
};

const de_player_choose_audio_track_aria_label = /** @type {(inputs: Player_Choose_Audio_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiospur auswählen`)
};

const it_player_choose_audio_track_aria_label = /** @type {(inputs: Player_Choose_Audio_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli la traccia audio`)
};

const ru_player_choose_audio_track_aria_label = /** @type {(inputs: Player_Choose_Audio_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите звуковую дорожку`)
};

const es_player_choose_audio_track_aria_label = /** @type {(inputs: Player_Choose_Audio_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir pista de audio`)
};

const zh_cn2_player_choose_audio_track_aria_label = /** @type {(inputs: Player_Choose_Audio_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择音轨`)
};

const ja_player_choose_audio_track_aria_label = /** @type {(inputs: Player_Choose_Audio_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオトラックを選択`)
};

const hi_player_choose_audio_track_aria_label = /** @type {(inputs: Player_Choose_Audio_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो ट्रैक चुनें`)
};

const pt_pt2_player_choose_audio_track_aria_label = /** @type {(inputs: Player_Choose_Audio_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione a faixa de áudio`)
};

/**
* | output |
* | --- |
* | "Choose audio track" |
*
* @param {Player_Choose_Audio_Track_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_choose_audio_track_aria_label = /** @type {((inputs?: Player_Choose_Audio_Track_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Choose_Audio_Track_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_choose_audio_track_aria_label(inputs)
	if (locale === "de") return de_player_choose_audio_track_aria_label(inputs)
	if (locale === "it") return it_player_choose_audio_track_aria_label(inputs)
	if (locale === "ru") return ru_player_choose_audio_track_aria_label(inputs)
	if (locale === "es") return es_player_choose_audio_track_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_player_choose_audio_track_aria_label(inputs)
	if (locale === "ja") return ja_player_choose_audio_track_aria_label(inputs)
	if (locale === "hi") return hi_player_choose_audio_track_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_player_choose_audio_track_aria_label(inputs)
	return en_player_choose_audio_track_aria_label(inputs)
});